export interface ExclusionState {
    excluded_file_ids: string[];
    revision: string;
}

export interface UploadedFile {
    id: string;
    openai_file_id: string;
    vector_store_file_id: string;
    tenant_id: string;
    user_id?: string;
    filename: string;
    original_filename: string;
    file_size: number;
    mime_type: string;
    status: "processing" | "completed" | "failed";
    uploaded_by: string;
    uploaded_at: number;
    processed_at?: number;
    error_message?: string;
    blob_url?: string;
    blob_name?: string;
}

export const SUPPORTED_FILE_EXTENSIONS = [".pdf", ".doc", ".docx", ".pptx", ".txt", ".md"];

export const SUPPORTED_MIME_TYPES = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "text/plain",
    "text/markdown",
];

export function formatFileSize(bytes: number): string {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
}

export function getFileExtension(filename: string): string {
    return filename.toLowerCase().substring(filename.lastIndexOf("."));
}

export function isFileSupported(filename: string): boolean {
    const ext = getFileExtension(filename);
    return SUPPORTED_FILE_EXTENSIONS.includes(ext);
}

export const MAX_FILE_SIZE = 50 * 1024 * 1024;

export function validateFile(file: File): string | null {
    if (!isFileSupported(file.name)) {
        return `${file.name}: Unsupported file type. Supported: ${SUPPORTED_FILE_EXTENSIONS.join(", ")}`;
    }
    if (file.size > MAX_FILE_SIZE) {
        return `${file.name}: File size must be less than 50MB`;
    }
    return null;
}

export function getMimeType(filename: string): string {
    const ext = filename.toLowerCase().substring(filename.lastIndexOf("."));
    const mimeMap: Record<string, string> = {
        ".pdf": "application/pdf",
        ".doc": "application/msword",
        ".docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ".pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        ".txt": "text/plain",
        ".md": "text/markdown",
    };
    return mimeMap[ext] || "application/octet-stream";
}
